<!-- <div class="page-header text-center my-3"
*ngIf="permissionsReady && permissions.canView && !loader">
    <h4 class="text-center mb-2 text-danger">
        📋 Plant Comparison Report (UAT – Not Final)
    </h4>
</div> -->

<div class="dashboard-main container-fluid" *ngIf="loader" style="height: 550px;">
    <div class="loaderwrapper" style="z-index: 1024;">
        <span class="loader"></span>
    </div>
</div>
<section class="dashboard-main container-fluid" *ngIf="permissionsReady && permissions.canView && !loader">
    <div class="contents-main">
        <div class="card table-card mb-3">
            <!-- Title, filters and the page action share one row at the top
                 of the card rather than stacking above it. -->
            <div class="table-toolbar">
                <h1 class="table-toolbar__title">Plant Comparison</h1>
                <div class="sb-filter-holder sb-filter-holder--inline">
                    <div class="input-wrapper daterange-wrapper">
                        <input type="text" class="sb-filter-field sb-filter-field--md" bsDatepicker
                            [(ngModel)]="selectedDate" [bsConfig]="datePickerConfig" #dp="bsDatepicker"
                            (ngModelChange)="onRangeChange($event)" placeholder="Month" />

                        <span class="sb-filter-date-icon" (click)="dp.toggle()">
                            <span><svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16"
                                    fill="none">
                                    <path
                                        d="M12.8046 1.60066H12.0042V0H10.4036V1.60066H4.00087V0H2.40021V1.60066H1.59987C1.39011 1.60066 1.18241 1.64213 0.988734 1.72268C0.795054 1.80324 0.619218 1.9213 0.471327 2.07006C0.323435 2.21882 0.206406 2.39535 0.126986 2.5895C0.0475649 2.78365 0.00731745 2.99157 0.00854826 3.20133L0.000549316 14.3993C0.000549316 14.8239 0.169189 15.231 0.469373 15.5312C0.769556 15.8314 1.17669 16 1.60121 16H12.7992C13.2237 16 13.6309 15.8314 13.9311 15.5312C14.2312 15.231 14.3999 14.8239 14.3999 14.3993V3.20133C14.3999 2.77773 14.232 2.37141 13.933 2.07138C13.6339 1.77135 13.2282 1.60208 12.8046 1.60066ZM12.8046 14.398H1.60655V5.59433H12.8046V14.398Z"
                                        fill="currentColor" />
                                </svg></span>
                        </span>
                    </div>
                </div>
                <button class="btn btn-dark rounded" (click)="downloadReport()">
                    <ng-container *ngIf="!isDownloading; else downloading">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                            class="me-2">
                            <path d="M10 1.5V14.5L14 10.1667" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10 14.5L5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M1 18.5H19" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg> Download Report
                    </ng-container>
                    <ng-template #downloading>
                        <span class="spinner-border spinner-border-sm me-2"></span> Downloading...
                    </ng-template>
                </button>
            </div>
        </div>
        <div class="row new mb-3 align-items-center">
            <div class="col-12 bg-white">
                <form [formGroup]="reportForm" (ngSubmit)="onSubmit()" class="form-wrapper-inline">
                    <!-- Date Selection -->
                    <!-- <div class="row mb-4">
                        <div class="col-md-12">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Report Date
                                    </label>
                                    <input type="date" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="date" />
                                </div>
                                <small *ngIf="isFieldInvalid('date')" class="text-danger m-1">
                                    {{ getErrorMessage('date') }}
                                </small>
                            </div>
                        </div>
                    </div> -->

                    <!-- Plant A Section -->
                    <div class="row mb-4">
                        <div class="col-md-12">
                            <h3 class="mb-3">
                                <span class="text-orange">Plant A</span>
                            </h3>
                        </div>

                        <div class="col-md-12 mb-3">
                            <ng-select [items]="filteredPlantList1" bindLabel="stationName" placeholder="Select Plant A"
                                bindValue="stationCode" (change)="selectPlantA($event)" [clearable]="false"
                                formControlName="plantA">
                            </ng-select>
                            <small *ngIf="isFieldInvalid('plantA')" class="text-danger">
                                {{ getErrorMessage('plantA') }}
                            </small>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Cleaning Status
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="cleaning_status_plant_a" placeholder="Enter status">
                                    <small *ngIf="isFieldInvalid('cleaning_status_plant_a')" class="text-danger m-1">
                                        {{ getErrorMessage('cleaning_status_plant_a') }}
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Corrective Maintenance
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="corrective_maintenance_plant_a"
                                        placeholder="Enter maintenance details">
                                </div>
                                <small *ngIf="isFieldInvalid('corrective_maintenance_plant_a')" class="text-danger m-1">
                                    {{ getErrorMessage('corrective_maintenance_plant_a') }}
                                </small>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Spare Parts Replacement
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="spare_parts_replacement_plant_a" placeholder="Enter details">
                                </div>
                                <small *ngIf="isFieldInvalid('spare_parts_replacement_plant_a')"
                                    class="text-danger m-1">
                                    {{ getErrorMessage('spare_parts_replacement_plant_a') }}
                                </small>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Unplanned Downtime (hrs)
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="unplanned_downtime_plant_a" placeholder="0.00"
                                        maxlength="10" />
                                </div>
                                <small *ngIf="isFieldInvalid('unplanned_downtime_plant_a')" class="text-danger m-1">
                                    {{ getErrorMessage('unplanned_downtime_plant_a') }}
                                </small>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Lost Generation (kWh)
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="lost_generation_plant_a" placeholder="0.00" maxlength="10" />
                                </div>
                                <small *ngIf="isFieldInvalid('lost_generation_plant_a')" class="text-danger m-1">
                                    {{ getErrorMessage('lost_generation_plant_a') }}
                                </small>
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        PV Modules
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="pv_modules_plant_a" placeholder="Enter details">
                                </div>
                                <small *ngIf="isFieldInvalid('pv_modules_plant_a')" class="text-danger m-1">
                                    {{ getErrorMessage('pv_modules_plant_a') }}
                                </small>
                            </div>
                        </div>

                        <!-- <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Communication Issue
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="communication_issue_plant_a" placeholder="Optional" />
                                </div>
                            </div>
                        </div> -->

                        <!-- <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Grid Issue
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="grid_issue_plant_a" placeholder="Optional" />
                                </div>
                            </div>
                        </div> -->

                        <!-- <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Other Issue
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="other_issue_plant_a" placeholder="Optional" />
                                </div>
                            </div>
                        </div> -->
                    </div>

                    <!-- Plant B Section -->
                    <div class="row mb-4">
                        <div class="col-md-12">
                            <h3 class="mb-3">
                                <span class="text-orange">Plant B</span>
                            </h3>
                        </div>

                        <div class="col-md-12 mb-3">
                            <ng-select [items]="filteredPlantList2" bindLabel="stationName" placeholder="Select Plant B"
                                bindValue="stationCode" (change)="selectPlantB($event)" [clearable]="false"
                                formControlName="plantB">
                            </ng-select>
                            <small *ngIf="isFieldInvalid('plantB')" class="text-danger">
                                {{ getErrorMessage('plantB') }}
                            </small>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Cleaning Status
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="cleaning_status_plant_b" placeholder="Enter status">
                                </div>
                                <small *ngIf="isFieldInvalid('cleaning_status_plant_b')" class="text-danger m-1">
                                    {{ getErrorMessage('cleaning_status_plant_b') }}
                                </small>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Corrective Maintenance
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="corrective_maintenance_plant_b"
                                        placeholder="Enter maintenance details">
                                </div>
                                <small *ngIf="isFieldInvalid('corrective_maintenance_plant_b')" class="text-danger m-1">
                                    {{ getErrorMessage('corrective_maintenance_plant_b') }}
                                </small>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Spare Parts Replacement
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="spare_parts_replacement_plant_b" placeholder="Enter details">
                                </div>
                                <small *ngIf="isFieldInvalid('spare_parts_replacement_plant_b')"
                                    class="text-danger m-1">
                                    {{ getErrorMessage('spare_parts_replacement_plant_b') }}
                                </small>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Unplanned Downtime (hrs)
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="unplanned_downtime_plant_b" placeholder="0.00"
                                        maxlength="10" />
                                </div>
                                <small *ngIf="isFieldInvalid('unplanned_downtime_plant_b')" class="text-danger m-1">
                                    {{ getErrorMessage('unplanned_downtime_plant_b') }}
                                </small>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Lost Generation (kWh)
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="lost_generation_plant_b" placeholder="0.00" maxlength="10" />
                                </div>
                                <small *ngIf="isFieldInvalid('lost_generation_plant_b')" class="text-danger m-1">
                                    {{ getErrorMessage('lost_generation_plant_b') }}
                                </small>
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        PV Modules
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="pv_modules_plant_b" placeholder="Enter details">
                                </div>
                                <small *ngIf="isFieldInvalid('pv_modules_plant_b')" class="text-danger m-1">
                                    {{ getErrorMessage('pv_modules_plant_b') }}
                                </small>
                            </div>
                        </div>

                        <!-- <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Communication Issue
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="communication_issue_plant_b" placeholder="Optional" />
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Grid Issue
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="grid_issue_plant_b" placeholder="Optional" />
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Other Issue
                                    </label>
                                    <input type="text" class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="other_issue_plant_b" placeholder="Optional" />
                                </div>
                            </div>
                        </div> -->
                    </div>

                    <!-- Recommendations Section -->
                    <div class="row mb-4">
                        <div class="col-md-12">
                            <div class="d-flex flex-column border input-group form-inline">
                                <div class="d-flex w-100">
                                    <label
                                        class="bg-light border-end d-flex align-items-center justify-content-start p-2 flex-fill equal-width">
                                        Recommendations
                                    </label>
                                    <textarea class="form-control border-0 p-2 flex-fill equal-width"
                                        formControlName="recommendations" rows="4"
                                        placeholder="Enter your recommendations here (minimum 10 characters)"></textarea>
                                </div>
                                <small *ngIf="isFieldInvalid('recommendations')" class="text-danger m-1">
                                    {{ getErrorMessage('recommendations') }}
                                </small>
                            </div>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="row">
                        <div class="col-12 d-flex justify-content-end gap-2">
                            <button type="button" class="btn btn-outline-light rounded" (click)="resetForm()">
                                Reset
                            </button>
                            <button type="submit" class="btn btn-dark rounded">
                                Generate Report
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12 bg-white px-5 py-5 mb-3">
                <div class="row" *ngIf="comparisonList">
                    <div class="col-md-12">
                        <h2 class="mb-3">
                            <span class="text-orange">Solar Plant Analysis Report</span>
                        </h2>
                        <!-- Plant Technical Details -->
                        <div class="table-wrap table-shadow mb-4">
                            <div class="table-main">
                                <table class="table-data text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" class="text-start">PLANT TECHNICAL DETAILS</th>
                                            <th>PLANT A ({{ comparisonList?.plant_a?.station_name || '-' }})</th>
                                            <th>PLANT B ({{ comparisonList?.plant_b?.station_name || '-' }})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-start">Installed Capacity (KW)</td>
                                            <td>{{ comparisonList?.plant_a?.technical_details?.installed_capacity_kw ||
                                                '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.technical_details?.installed_capacity_kw ||
                                                '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Inverter Type</td>
                                            <td>{{ comparisonList?.plant_a?.technical_details?.inverter_type || '-' }}
                                            </td>
                                            <td>{{ comparisonList?.plant_b?.technical_details?.inverter_type || '-' }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">PV Modules</td>
                                            <td>{{ comparisonList?.plant_a?.technical_details?.pv_modules || '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.technical_details?.pv_modules || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Number of Inverters</td>
                                            <td>{{ comparisonList?.plant_a?.technical_details?.number_of_inverters ||
                                                '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.technical_details?.number_of_inverters ||
                                                '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Commissioning Date</td>
                                            <td>{{ comparisonList?.plant_a?.technical_details?.commissioning_date || '-'
                                                }}</td>
                                            <td>{{ comparisonList?.plant_b?.technical_details?.commissioning_date || '-'
                                                }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Performance Analysis -->
                        <div class="table-wrap table-shadow mb-4">
                            <div class="table-main">
                                <table class="table-data text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" class="text-start">PERFORMANCE ANALYSIS</th>
                                            <th>PLANT A ({{ comparisonList?.plant_a?.station_name || '-' }})</th>
                                            <th>PLANT B ({{ comparisonList?.plant_b?.station_name || '-' }})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-start">Daily Avg. Generation (KWH)</td>
                                            <td>{{
                                                comparisonList?.plant_a?.performance_analysis?.daily_avg_generation_kwh
                                                || '-' }}</td>
                                            <td>{{
                                                comparisonList?.plant_b?.performance_analysis?.daily_avg_generation_kwh
                                                || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Monthly Generation (KWH)</td>
                                            <td>{{ comparisonList?.plant_a?.performance_analysis?.monthly_generation_kwh
                                                || '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.performance_analysis?.monthly_generation_kwh
                                                || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Specific Yield (KWH/KWP)</td>
                                            <td>{{
                                                comparisonList?.plant_a?.performance_analysis?.specific_yield_kwh_per_kwp
                                                || '-' }}</td>
                                            <td>{{
                                                comparisonList?.plant_b?.performance_analysis?.specific_yield_kwh_per_kwp
                                                || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Performance Ratio (PR %)</td>
                                            <td>{{
                                                comparisonList?.plant_a?.performance_analysis?.performance_ratio_percent
                                                || '-' }}</td>
                                            <td>{{
                                                comparisonList?.plant_b?.performance_analysis?.performance_ratio_percent
                                                || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Grid Export (KWH)</td>
                                            <td>{{ comparisonList?.plant_a?.performance_analysis?.grid_export_kwh || '-'
                                                }}</td>
                                            <td>{{ comparisonList?.plant_b?.performance_analysis?.grid_export_kwh || '-'
                                                }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Self-Consumption (KWH)</td>
                                            <td>{{ comparisonList?.plant_a?.performance_analysis?.self_consumption_kwh
                                                || '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.performance_analysis?.self_consumption_kwh
                                                || '-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Operational Status -->
                        <div class="table-wrap table-shadow mb-4">
                            <div class="table-main">
                                <table class="table-data text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" class="text-start">OPERATIONAL STATUS</th>
                                            <th>PLANT A ({{ comparisonList?.plant_a?.station_name || '-' }})</th>
                                            <th>PLANT B ({{ comparisonList?.plant_b?.station_name || '-' }})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-start">Status</td>
                                            <td>{{ comparisonList?.plant_a?.operational_status?.status || '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.operational_status?.status || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Inverter Issues</td>
                                            <td>{{ comparisonList?.plant_a?.operational_status?.inverter_issues || '-'
                                                }}</td>
                                            <td>{{ comparisonList?.plant_b?.operational_status?.inverter_issues || '-'
                                                }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Grid Connectivity</td>
                                            <td>{{ comparisonList?.plant_a?.operational_status?.grid_connectivity || '-'
                                                }}</td>
                                            <td>{{ comparisonList?.plant_b?.operational_status?.grid_connectivity || '-'
                                                }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Issues & Faults -->
                        <div class="table-wrap table-shadow mb-4">
                            <div class="table-main">
                                <table class="table-data text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" class="text-start">ISSUES & FAULTS</th>
                                            <th>PLANT A ({{ comparisonList?.plant_a?.station_name || '-' }})</th>
                                            <th>PLANT B ({{ comparisonList?.plant_b?.station_name || '-' }})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-start">Module Issues</td>
                                            <td>{{ comparisonList?.plant_a?.issues_faults?.module_issues || '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.issues_faults?.module_issues || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Communication Issues</td>
                                            <td>{{ comparisonList?.plant_a?.issues_faults?.communication_issues || '-'
                                                }}</td>
                                            <td>{{ comparisonList?.plant_b?.issues_faults?.communication_issues || '-'
                                                }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Grid Issues</td>
                                            <td>{{ comparisonList?.plant_a?.issues_faults?.grid_issues || '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.issues_faults?.grid_issues || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Other Issues</td>
                                            <td>{{ comparisonList?.plant_a?.issues_faults?.other_issues || '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.issues_faults?.other_issues || '-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Maintenance Activities -->
                        <div class="table-wrap table-shadow mb-4">
                            <div class="table-main">
                                <table class="table-data text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" class="text-start">MAINTENANCE ACTIVITIES</th>
                                            <th>PLANT A ({{ comparisonList?.plant_a?.station_name || '-' }})</th>
                                            <th>PLANT B ({{ comparisonList?.plant_b?.station_name || '-' }})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-start">Cleaning Status</td>
                                            <td>{{ comparisonList?.plant_a?.maintenance_activities?.cleaning_status ||
                                                '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.maintenance_activities?.cleaning_status ||
                                                '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Corrective Maintenance</td>
                                            <td>{{
                                                comparisonList?.plant_a?.maintenance_activities?.corrective_maintenance
                                                || '-' }}</td>
                                            <td>{{
                                                comparisonList?.plant_b?.maintenance_activities?.corrective_maintenance
                                                || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Spare Parts Replacement</td>
                                            <td>{{
                                                comparisonList?.plant_a?.maintenance_activities?.spare_parts_replacement
                                                || '-' }}</td>
                                            <td>{{
                                                comparisonList?.plant_b?.maintenance_activities?.spare_parts_replacement
                                                || '-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Downtime Analysis -->
                        <div class="table-wrap table-shadow mb-4">
                            <div class="table-main">
                                <table class="table-data text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" class="text-start">DOWNTIME ANALYSIS</th>
                                            <th>PLANT A ({{ comparisonList?.plant_a?.station_name || '-' }})</th>
                                            <th>PLANT B ({{ comparisonList?.plant_b?.station_name || '-' }})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-start">Planned Downtime (hrs)</td>
                                            <td>{{ comparisonList?.plant_a?.downtime_analysis?.planned_downtime_hrs ||
                                                '0' }}</td>
                                            <td>{{ comparisonList?.plant_b?.downtime_analysis?.planned_downtime_hrs ||
                                                '0' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Unplanned Downtime (hrs)</td>
                                            <td>{{ comparisonList?.plant_a?.downtime_analysis?.unplanned_downtime_hrs ||
                                                '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.downtime_analysis?.unplanned_downtime_hrs ||
                                                '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Lost Generation (KWH)</td>
                                            <td>{{ comparisonList?.plant_a?.downtime_analysis?.lost_generation_kwh ||
                                                '-' }}</td>
                                            <td>{{ comparisonList?.plant_b?.downtime_analysis?.lost_generation_kwh ||
                                                '-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Environmental Impact -->
                        <div class="table-wrap table-shadow mb-4">
                            <div class="table-main">
                                <table class="table-data text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" class="text-start">ENVIRONMENTAL IMPACT</th>
                                            <th>PLANT A ({{ comparisonList?.plant_a?.station_name || '-' }})</th>
                                            <th>PLANT B ({{ comparisonList?.plant_b?.station_name || '-' }})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-start">CO2 Avoided (Tons/month)</td>
                                            <td>{{
                                                comparisonList?.plant_a?.environmental_impact?.co2_avoided_tons_per_month
                                                || '-' }}</td>
                                            <td>{{
                                                comparisonList?.plant_b?.environmental_impact?.co2_avoided_tons_per_month
                                                || '-' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Equivalent Trees Planted</td>
                                            <td>{{
                                                comparisonList?.plant_a?.environmental_impact?.equivalent_trees_planted
                                                || '-' }}</td>
                                            <td>{{
                                                comparisonList?.plant_b?.environmental_impact?.equivalent_trees_planted
                                                || '-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Recommendations -->
                        <div class="table-wrap table-shadow mb-4">
                            <div class="table-main">
                                <table class="table-data text-center">
                                    <thead>
                                        <tr>
                                            <th class="text-start">RECOMMENDATIONS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-start">
                                                {{ comparisonList?.plant_a?.recommendations ||
                                                comparisonList?.plant_b?.recommendations || 'No recommendations
                                                available' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Show message when no data -->
                <div class="row" *ngIf="!comparisonList">
                    <div class="col-md-12">
                        <div class="alert alert-info text-center">
                            <p class="mb-0">No comparison data available. Please generate a report first.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- NO VIEW PERMISSION (FULL PAGE) -->
<section *ngIf="permissionsReady && !permissions.canView && !loader" class="dashboard-main container-fluid bg-white">
    <div class="contents-main">
        <div class="row">
            <div class="col-12">
                <div class="empty-state text-center d-flex flex-column align-items-center justify-content-center py-5">
                    <i class="fa fa-lock fa-3x mb-3 text-muted"></i>
                    <h5 class="mb-2">Access Restricted</h5>
                    <p class="text-muted">
                        You don’t have permission to view this report.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #LoadingRow>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </td>
    </tr>
</ng-template>
<ng-template #noRow>
    <tr>
        <td colspan="100">
            <div class="fw-semibold text-center text-muted">
                No data found
            </div>
        </td>
    </tr>
</ng-template>

<ng-template #initialMessage>
    <tr>
        <td colspan="7" class="fw-semibold text-center text-muted">
            Please apply plant and date filter to view the report.
        </td>
    </tr>
</ng-template>

<ng-template>
    <div class="row">
        <div class="col-md-12">
            <h2 class="mb-3">
                <span class="text-orange">Solar Plant Analysis Report </span>
            </h2>
            <div class="table-wrap table-shadow mb-4">
                <div class="table-main">
                    <table class="table-data text-center">
                        <thead>
                            <tr>
                                <th width="50%" class="text-start">PLANT TECHNICAL DETAILS</th>
                                <th>PLANT A (Campus 1)</th>
                                <th>PLANT B (Campus)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-start">Installed Capacity (KW)</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Inverter Type</td>
                                <td>Inverter Type</td>
                                <td>{{plantDetails?.header?.POC || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">PV Modules</td>
                                <td>PV Modules</td>
                                <td>{{plantDetails?.header?.Contact || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Number of Inverters</td>
                                <td>{{plantDetails?.header?.CommissionDate || '-'}}</td>
                                <td>Number of Inverters</td>
                            </tr>
                            <tr>
                                <td class="text-start">Commissioning Date</td>
                                <td>Commissioning Date</td>
                                <td>{{plantDetails?.header?.TotalPVSize || '-'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="table-wrap table-shadow mb-4">
                <div class="table-main">
                    <table class="table-data text-center">
                        <thead>
                            <tr>
                                <th width="50%" class="text-start">PERFORMANCE ANALYSIS</th>
                                <th>PLANT A (Campus 1)</th>
                                <th>PLANT B (Campus)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-start">Daily Avg. Generation (KWH)</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Monthly Generation (KWH)</td>
                                <td>Inverter Type</td>
                                <td>{{plantDetails?.header?.POC || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Specific Yield (KWH/KWP)</td>
                                <td>PV Modules</td>
                                <td>{{plantDetails?.header?.Contact || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Performance Ratio (PR %)</td>
                                <td>{{plantDetails?.header?.CommissionDate || '-'}}</td>
                                <td>Number of Inverters</td>
                            </tr>
                            <tr>
                                <td class="text-start">Performance Ratio (PR %)</td>
                                <td>Commissioning Date</td>
                                <td>{{plantDetails?.header?.TotalPVSize || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Grid Export (KWH) in short Wapda export (negative
                                    value)</td>
                                <td>Commissioning Date</td>
                                <td>{{plantDetails?.header?.TotalPVSize || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Self-Consumption (KWH)</td>
                                <td>Commissioning Date</td>
                                <td>{{plantDetails?.header?.TotalPVSize || '-'}}</td>
                            </tr>
                            <!-- <tr>
                                            <td class="text-start">WAPDA Import is Grid Import (Positive Value)</td>
                                            <td>Commissioning Date</td>
                                            <td>{{plantDetails?.header?.TotalPVSize || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Grid Meter (Import value only positive one)</td>
                                            <td>Commissioning Date</td>
                                            <td>{{plantDetails?.header?.TotalPVSize || '-'}}</td>
                                        </tr> -->
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="table-wrap table-shadow mb-4">
                <div class="table-main">
                    <table class="table-data text-center">
                        <thead>
                            <tr>
                                <th width="50%" class="text-start">Operational Status</th>
                                <th>PLANT A (Campus 1)</th>
                                <th>PLANT B (Campus)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-start">Status</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Inverter Issues</td>
                                <td>Inverter Type</td>
                                <td>{{plantDetails?.header?.POC || '-'}}</td>
                            </tr>
                            <!-- <tr>
                                            <td class="text-start">String Voltage Uniformity</td>
                                            <td>PV Modules</td>
                                            <td>{{plantDetails?.header?.Contact || '-'}}</td>
                                        </tr> -->
                            <tr>
                                <td class="text-start">Grid Connectivity</td>
                                <td>{{plantDetails?.header?.CommissionDate || '-'}}</td>
                                <td>Number of Inverters</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- <div class="table-wrap table-shadow mb-4">
                            <div class="table-main">
                                <table class="table-data text-center">
                                    <thead>
                                        <tr>
                                            <th width="50%" class="text-start">Total Alarms</th>
                                            <th>PLANT A (Campus 1)</th>
                                            <th>PLANT B (Campus)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-start">-</td>
                                            <td>{{plantDetails?.header?.Client || '-'}}</td>
                                            <td>{{plantDetails?.header?.Client || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">-</td>
                                            <td>Inverter Type</td>
                                            <td>{{plantDetails?.header?.POC || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-start">Others</td>
                                            <td>PV Modules</td>
                                            <td>{{plantDetails?.header?.Contact || '-'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div> -->
            <div class="table-wrap table-shadow mb-4">
                <div class="table-main">
                    <table class="table-data text-center">
                        <thead>
                            <tr>
                                <th width="50%" class="text-start">Maintenance Activities</th>
                                <th>PLANT A (Campus 1)</th>
                                <th>PLANT B (Campus)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-start">Cleaning Status</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Corrective Maintenance</td>
                                <td>Inverter Type</td>
                                <td>{{plantDetails?.header?.POC || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Spare Parts Replacement</td>
                                <td>PV Modules</td>
                                <td>{{plantDetails?.header?.Contact || '-'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="table-wrap table-shadow mb-4">
                <div class="table-main">
                    <table class="table-data text-center">
                        <thead>
                            <tr>
                                <th width="50%" class="text-start">Downtime Analysis</th>
                                <th>PLANT A (Campus 1)</th>
                                <th>PLANT B (Campus)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-start">Planned Downtime (hrs)</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Unplanned Downtime (hrs)</td>
                                <td>Inverter Type</td>
                                <td>{{plantDetails?.header?.POC || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Lost Generation (KWH)</td>
                                <td>PV Modules</td>
                                <td>{{plantDetails?.header?.Contact || '-'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="table-wrap table-shadow mb-4">
                <div class="table-main">
                    <table class="table-data text-center">
                        <thead>
                            <tr>
                                <th width="50%" class="text-start">ENVIRONMENTAL IMPACT</th>
                                <th>PLANT A (Campus 1)</th>
                                <th>PLANT B (Campus)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-start">CO2 Avoided (Tons/month)</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                                <td>{{plantDetails?.header?.Client || '-'}}</td>
                            </tr>
                            <tr>
                                <td class="text-start">Equivalent Trees Planted</td>
                                <td>Inverter Type</td>
                                <td>{{plantDetails?.header?.POC || '-'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="table-wrap table-shadow mb-4">
                <div class="table-main">
                    <table class="table-data text-center">
                        <thead>
                            <tr>
                                <th class="text-start">Recommendations</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-start">Lorem ipsum is a dummy text</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</ng-template>